import React from 'react'

import './Content.scss'

const Content = ({ children }: any): JSX.Element => {
  return <div className="content-container fade-in-bottom">{children}</div>
}

export default Content
